<div>
    <div class="main-div">
        <div *ngIf="pageLoaded ; else spin">
            <mat-form-field appearance="fill" class='matwidth'>
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
                    <input matStartDate placeholder="Start date" [(ngModel)]="dateRangeStart">
                    <input matEndDate placeholder="End date" [(ngModel)]="dateRangeEnd">
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>

            <button class="btn-warning" style="display: flex;float: right;"
                (click)="clearSelectedDates()">Reset</button>
            <br>
            <button class="btn-success" (click)='selectedDates()'>submit</button>
            <br> <br>
            <div *ngIf="previousAnalysisKeys.length > 0; else spin">
                <card  [title]="'Report Analysis'" class="mb-0">
                    <mat-form-field>
                        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                    </mat-form-field>
                    <div class="col-md-4 text-right">
                        <button class="btn btn-success btn-block" (click)="openPDF1()">Download PDF</button>
                    </div>
                    <mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort id="htmlData1">
                        <ng-container matColumnDef="analyteName">
                            <mat-header-cell *matHeaderCellDef> File Name or Target Name</mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <div *ngIf="element.file_name ==='No Data'">
                                    {{element?.file_name
                                    }}</div>
                                <div *ngIf="element.file_name !=='No Data'"><a
                                        [routerLink]="[getUrl(element.analysis_type), element.analysis_id, element.user_id, {type: 'previous'}]">{{element.file_name
                                        }} </a></div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="analysisDate">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> RedThread Analysis Date(UTC)
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element?.analysis_date
                                }} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="projectNames">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Project </mat-header-cell>

                            <mat-cell *matCellDef="let element">
                                <div *ngIf="element.project_code ==='No Data'">{{element.project_code}}</div>
                                <div *ngIf="element.project_code !=='No Data'">
                                    <a
                                        [routerLink]="[getUrl(element.analysis_type), element.analysis_id, element.user_id,{type: 'previous'}]">{{element.project_code}}</a>
                                </div>
                            </mat-cell>

                        </ng-container>
                        <ng-container matColumnDef="analysisType">
                            <mat-header-cell *matHeaderCellDef> Analysis Type </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.analysis_type}} </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="tableColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: tableColumns;"></mat-row>
                    </mat-table>
                    <mat-paginator #RApaginator [length]="dataSource" [pageSizeOptions]="[ 10, 20]"
                        showFirstLastButtons></mat-paginator>
                </card>
            </div>
        </div>

        <ng-template #spin>
            <div><mat-spinner style="margin:0 auto;" mode="indeterminate" [diameter]="200"></mat-spinner></div>
        </ng-template>
    </div>
</div>